import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Stack, Box, CircularProgress } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { cancelButtonSx, dangerButtonSx } from "./buttonStyles";

const trainingCount = (curriculum) => {
	const count = curriculum?.trainings?.length ?? 0;
	return `${count} ${count === 1 ? "training" : "trainings"}`;
};

const DeleteCurriculumDialog = ({ open, onClose, onConfirm, curriculum, deleting = false }) => (
	// Backdrop dismissal is suppressed mid-delete so the dialog cannot be closed out from under
	// a request that is still running.
	<Dialog open={open} onClose={deleting ? undefined : onClose} fullWidth maxWidth="xs" slotProps={{ paper: { sx: { borderRadius: 3 } } }}>
		<DialogTitle sx={{ pb: 1 }}>
			<Stack direction="row" spacing={1.5} alignItems="center">
				<Box
					sx={{
						width: 40,
						height: 40,
						borderRadius: "50%",
						backgroundColor: "#FFF0F2",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<WarningAmberIcon sx={{ color: "error.main" }} />
				</Box>
				<Typography variant="h6" sx={{ fontWeight: 700 }}>
					Delete Curriculum
				</Typography>
			</Stack>
		</DialogTitle>

		<DialogContent>
			<Typography variant="body2" color="text.secondary">
				Are you sure you want to delete{" "}
				<Box component="span" sx={{ fontWeight: 700, color: "text.primary" }}>
					{curriculum?.title}
				</Box>
				? Its {trainingCount(curriculum)} and every attendance badge earned from them will be removed.
			</Typography>
		</DialogContent>

		<DialogActions sx={{ px: 3, pb: 2 }}>
			<Button onClick={onClose} disabled={deleting} sx={cancelButtonSx}>
				Cancel
			</Button>

			<Box sx={{ position: "relative", display: "inline-flex" }}>
				<Button
					onClick={onConfirm}
					variant="contained"
					disabled={deleting}
					aria-busy={deleting}
					sx={{
						...dangerButtonSx,
						"&.Mui-disabled": {
							color: "#FFFFFF !important",
							backgroundColor: "#E14B5A !important",
							opacity: 1,
						},
					}}
				>
					{deleting ? "" : "Delete"}
				</Button>

				{deleting && (
					<CircularProgress
						size={20}
						thickness={5}
						sx={{
							color: "#FFFFFF",
							position: "absolute",
							top: "50%",
							left: "50%",
							mt: "-10px",
							ml: "-10px",
							pointerEvents: "none",
						}}
					/>
				)}
			</Box>
		</DialogActions>
	</Dialog>
);

export default DeleteCurriculumDialog;
